module.exports = __webpack_public_path__ + "static/media/NoirPro-SemiBold.1bc66a4b.woff";